<template>
  <section class="bg-white rounded-lg border border-geyser p-5 md:p-8">
    <div class="flex flex-col space-y-6">
      <div class="flex flex-col space-y-2">
        <h2 class="text-22px leading-26px font-bold text-primary">FAQ для исполнителей iWALY</h2>
        <p class="text-14px leading-20px text-muted max-w-3xl">
          Главное, что нужно понимать до регистрации, после активации аккаунта
          и перед акцептом первых заказов.
        </p>
      </div>

      <div class="flex flex-col space-y-3 contractor-faq">
        <details open>
          <summary>1. Что такое iWALY и зачем регистрироваться исполнителем</summary>
          <div>
            <p>
              iWALY — сервис по созданию архива семейных захоронений, а также
              дистанционных услуг по поиску, уборке, доставке цветов,
              благоустройству и другим работам на кладбищах.
            </p>
            <p>
              Для исполнителя это возможность получать дополнительные заказы
              через приложение: поиск захоронений, уборку, благоустройство,
              доставку цветов, индивидуальные поручения и волонтёрскую помощь.
            </p>
          </div>
        </details>

        <details>
          <summary>2. Как пройти регистрацию и что будет после</summary>
          <div>
            <p>
              Заполните анкету и укажите актуальный личный мобильный номер,
              email, регион, населённый пункт, услуги и комментарий о себе.
            </p>
            <p>
              После отправки мы проверяем данные. Если всё корректно, активируем
              аккаунт исполнителя либо связываемся с вами для уточнения деталей.
            </p>
            <p>
              Если вы уже писали нам в мессенджере, перенесите в комментарий
              информацию о себе: регион, опыт, транспорт, инструменты, портфолио,
              сайт, фотографии работ и удобный формат сотрудничества.
            </p>
          </div>
        </details>

        <details>
          <summary>3. Что такое акцепт заказа</summary>
          <div>
            <p>
              Акцепт заказа означает, что вы берёте заказ в работу и соглашаетесь
              с его условиями: стоимостью, локацией, сроками, составом работ,
              правилами сервиса и стандартами выполнения.
            </p>
            <p>Перед акцептом обязательно проверьте:</p>
            <ul>
              <li>подходит ли вам кладбище и локация;</li>
              <li>понятен ли объём работ;</li>
              <li>готовы ли вы выполнить заказ в срок;</li>
              <li>есть ли у вас инструменты, материалы и транспорт;</li>
              <li>устраивает ли вас стоимость;</li>
              <li>есть ли у вас релевантный опыт.</li>
            </ul>
            <p>Не акцептуйте заказ, если заранее понимаете, что не готовы его выполнить.</p>
          </div>
        </details>

        <details>
          <summary>4. Сроки после акцепта</summary>
          <div>
            <p>
              После акцепта стандартного заказа у исполнителя есть время на
              подготовку и планирование маршрута, если в приложении или конкретном
              заказе не указано иное.
            </p>
            <p>
              Если возник форс-мажор — плохая погода, закрытое кладбище, болезнь,
              невозможность пройти к участку, объективная задержка — не молчите.
              Напишите в чат заказа или команде iWALY.
            </p>
          </div>
        </details>

        <details>
          <summary>5. Виртуальный счёт и сервисное списание</summary>
          <div>
            <p>
              При акцепте заказа может применяться сервисное списание с виртуального
              счёта исполнителя. Виртуальный счёт пополняется из личного кабинета.
            </p>
            <p>
              Если баланс ниже допустимого уровня, исполнитель может видеть заказы,
              но не сможет брать новые до пополнения счёта.
            </p>
          </div>
        </details>

        <details>
          <summary>6. Предоплата и безопасная сделка</summary>
          <div>
            <p>
              Все заказы в iWALY оплачиваются через сервис. Деньги находятся в логике
              безопасной сделки: исполнитель не просит заказчика перевести деньги
              напрямую и не договаривается об оплате «на карту».
            </p>
            <p>
              После завершения заказа заказчик принимает работу. После приёмки
              высвобождается оплата исполнителю и комиссия сервиса.
            </p>
          </div>
        </details>

        <details>
          <summary>7. Выплаты</summary>
          <div>
            <p>
              Выплаты проходят только через предусмотренную платёжную логику сервиса
              на карту исполнителя, привязанную в личном кабинете.
            </p>
            <p>
              Нельзя просить заказчика оплатить заказ, доплатить напрямую,
              перевести деньги на карту или договориться в обход сервиса.
              Дополнительные работы должны оформляться через оператора и отдельный заказ.
            </p>
          </div>
        </details>

        <details>
          <summary>8. Как выполняется заказ</summary>
          <div>
            <ul>
              <li>Вы акцептуете заказ.</li>
              <li>После прибытия к захоронению нажимаете «Начать работу».</li>
              <li>Делаете реальные фото ДО.</li>
              <li>Выполняете работу и при необходимости уточняете детали в чате.</li>
              <li>После выполнения нажимаете «Завершить работу».</li>
              <li>Делаете финальные фото ПОСЛЕ.</li>
              <li>Оставляете комментарий по состоянию захоронения и рекомендациям.</li>
            </ul>
            <p>
              Фото ДО и ПОСЛЕ — обязательная часть выполнения. В случае спора
              именно фотографии хорошего качества являются главным подтверждением результата.
            </p>
          </div>
        </details>

        <details>
          <summary>9. Общение с заказчиком</summary>
          <div>
            <p>
              После акцепта желательно написать заказчику в чате: представиться,
              поблагодарить за заказ, сообщить ориентировочный срок выполнения
              и предложить оставить пожелания.
            </p>
            <p>
              Основная коммуникация должна идти в чате приложения. Если был звонок
              или внешняя договорённость, кратко зафиксируйте итог в чате.
            </p>
          </div>
        </details>

        <details>
          <summary>10. Стандартные уборки</summary>
          <div>
            <p>
              Уборка может включать очистку участка от мусора, сухой травы,
              веток, листьев и старых цветов, уборку проходов, влажную чистку
              памятника и элементов участка, удаление сорняков и фотоотчёт.
            </p>
            <p>
              Весь мусор после выполнения работ должен быть собран и утилизирован.
              Нельзя оставлять мусор на участке, в проходах или на соседних захоронениях.
            </p>
          </div>
        </details>

        <details>
          <summary>11. Доставка цветов</summary>
          <div>
            <p>
              В заказах с доставкой цветов исполнитель покупает или получает цветы,
              доставляет их на кладбище и аккуратно размещает на захоронении.
            </p>
            <p>
              Если нужных цветов нет из-за сезона или объективной недоступности,
              замену желательно согласовать с заказчиком в чате.
            </p>
          </div>
        </details>

        <details>
          <summary>12. Материалы, инструменты и дополнительные работы</summary>
          <div>
            <p>
              Всё необходимое для выполнения заказа должно быть у исполнителя в наличии
              или приобретено в короткий срок, если это входит в согласованный объём.
            </p>
            <p>
              Если по ходу выполнения появились дополнительные работы, требующие
              отдельной оплаты, они оформляются через новый заказ в системе,
              а не через перевод напрямую.
            </p>
          </div>
        </details>

        <details>
          <summary>13. Индивидуальные заказы</summary>
          <div>
            <p>
              Индивидуальный заказ — нестандартная задача, где заказчик описывает
              желаемый результат, а исполнитель оценивает возможность выполнения,
              сроки, материалы и итоговую стоимость.
            </p>
            <p>
              По таким заказам важно давать понятное предложение «под ключ»,
              а не размытый ответ «от такой-то суммы».
            </p>
          </div>
        </details>

        <details>
          <summary>14. Партнёрские и крупные проекты</summary>
          <div>
            <p>
              Партнёрский заказ — категория для крупных и профессиональных проектов:
              благоустройство участков, установка памятников, мемориальные комплексы,
              реставрация, монтажные, каменные, строительные или ландшафтные работы.
            </p>
            <p>
              Эта категория подходит подрядчикам, бригадам, мастерским или специалистам
              с подтверждённым опытом, портфолио, оборудованием и понятной зоной работы.
            </p>
          </div>
        </details>

        <details>
          <summary>15. Помощь волонтёров</summary>
          <div>
            <p>
              Помощь волонтёров — особая категория для небольших и социально значимых
              поручений: лёгкая уборка, несколько фотографий, проверка состояния участка,
              простая помощь с цветами, несложный поиск или ориентирование на кладбище.
            </p>
            <p>
              Это не обычный коммерческий заказ с жёсткими сроками и расширенными
              требованиями. Это просьба о человеческом участии к человеку, который
              живёт рядом или бывает в нужном районе и готов откликнуться.
            </p>
            <p>
              При этом речь не идёт о том, что исполнитель обязан работать бесплатно.
              В заказе будет минимальная разумная стоимость; заказчик может указать
              большую сумму, если считает это справедливым.
            </p>
          </div>
        </details>

        <details>
          <summary>16. Коротко: главная логика работы</summary>
          <div>
            <ul>
              <li>Заказы оплачиваются через сервис.</li>
              <li>После акцепта заказ закрепляется за исполнителем.</li>
              <li>Исполнитель выполняет работу по стандартам iWALY.</li>
              <li>Фото ДО и ПОСЛЕ обязательны.</li>
              <li>Все важные договорённости фиксируются в чате.</li>
              <li>Прямые переводы, доплаты на карту и работа в обход сервиса запрещены.</li>
            </ul>
          </div>
        </details>

        <details>
          <summary>17. Где читать полные правила</summary>
          <div>
            <p>
              Этот FAQ — краткое объяснение логики работы. Полные правила,
              стандарты, ограничения и юридические условия размещены в правовых документах iWALY.
            </p>
            <ul>
              <li><a href="https://iwaly.ru/rules" target="_blank" rel="nofollow noopener">Правила и стандарты iWALY</a></li>
              <li><a href="https://iwaly.ru/license" target="_blank" rel="nofollow noopener">Лицензионный договор / публичная оферта</a></li>
              <li><a href="https://iwaly.ru/policy" target="_blank" rel="nofollow noopener">Политика обработки и защиты персональных данных</a></li>
            </ul>
          </div>
        </details>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContractorFaq',
};
</script>

<style scoped>
.contractor-faq details {
  border: 1px solid #DBE1E7;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.contractor-faq summary {
  cursor: pointer;
  padding: 14px 16px;
  font-weight: 700;
  color: #282A2C;
  background: rgba(0, 160, 114, 0.055);
  outline: none;
}

.contractor-faq details[open] summary {
  color: #00A072;
  border-bottom: 1px solid #DBE1E7;
}

.contractor-faq details > div {
  padding: 14px 16px 16px;
  color: #282A2C;
  font-size: 15px;
  line-height: 22px;
}

.contractor-faq p {
  margin: 0 0 10px;
}

.contractor-faq ul {
  list-style: disc;
  margin: 8px 0 10px 22px;
}

.contractor-faq li {
  margin: 4px 0;
}

.contractor-faq a {
  color: #00A072;
  text-decoration: underline;
  font-weight: 600;
}
</style>
